var androidReg = /(Android)/i
var iosReg = /(iPhone|iPad|iPod|iOS)/i
// sinopecapp
// alert(navigator.userAgent)

if (navigator.userAgent.indexOf('sinopecapp') !== -1) {
  if (androidReg.test(navigator.userAgent)) {
    var sinopecapp_loadNative = function(method, param) {
      // eslint-disable-next-line no-undef
      return sinopecapp.sinopecapp_loadNative(method, param)
    }
  } else if (iosReg.test(navigator.userAgent)) {
    // eslint-disable-next-line no-redeclare
    var sinopecapp_loadNative = function(method, param) {
      return window.webkit.messageHandlers.sinopecapp_loadNative.postMessage({ method, param })
    }
  }
  else {
    // eslint-disable-next-line no-redeclare
    var sinopecapp_loadNative = function(method, param) {
      console.log(param, method)
      //revNativeValue('{"code":"0","method":"' + method + '","value":{"param":' + param + '}}')
    }
  }
} else {
  // eslint-disable-next-line no-redeclare
  var sinopecapp_loadNative = function(method, param) {
    console.log(param, method)
    //revNativeValue('{"code":"0","method":"' + method + '","value":{"param":' + param + '}}')
  }
}

// function revNativeValue(value) {
//   if (value) {
//     try {
//       const data = JSON.parse(value)
//       if (data) {
//         if (data.method && data.method === 'getRegionNo') {
//           store.dispatch('user/setProvince', data.value.regionNo)
//         }
//       }
//     } catch (e) {}
//   }
// }

// sinopecapp_loadNative('token', '{}')
export { sinopecapp_loadNative }
